/**
 * ユーザー情報の「新規登録」完了を、表示中の入力画面へ知らせるイベント。
 * 登録前に描画済みの入力画面が、課・チームの初期選択をやり直すために使う。
 * （編集時や通常起動時には発火しない）
 */
export const USER_REGISTERED_EVENT = 'weekly-user-registered';

export const notifyUserRegistered = (): void => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(USER_REGISTERED_EVENT));
};
